import { Variants, Transition } from 'motion/react'

export type AnimationDirection = 'forward' | 'backward' | 'recalculate'

export const slideVariants: Record<AnimationDirection, Variants> = {
  forward: {
    initial: { opacity: 0, x: 300, scale: 0.98 },
    animate: { opacity: 1, x: 0, scale: 1 },
    exit: { opacity: 0, x: -300, scale: 0.98 },
  },
  backward: {
    initial: { opacity: 0, x: -300, scale: 0.98 },
    animate: { opacity: 1, x: 0, scale: 1 },
    exit: { opacity: 0, x: 300, scale: 0.98 },
  },
  recalculate: {
    initial: { opacity: 0, rotateY: 90, scale: 0.95 },
    animate: { opacity: 1, rotateY: 0, scale: 1 },
    exit: { opacity: 0, rotateY: -90, scale: 0.95 },
  },
}

export const transitionConfig = {
  forward: { duration: 0.35, ease: [0.4, 0, 0.2, 1] as const },
  backward: { duration: 0.35, ease: [0.4, 0, 0.2, 1] as const },
  recalculate: { duration: 0.4, ease: [0.4, 0, 0.2, 1] as const },
}

export function getReducedMotionTransition(direction: AnimationDirection) {
  return {
    ...transitionConfig[direction],
    duration: 0.01,
  } as Transition
}

export function getAnimationVariants(
  direction: AnimationDirection,
  prefersReducedMotion: boolean
): { variants: Variants; transition: Transition } {
  if (prefersReducedMotion) {
    return {
      variants: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      },
      transition: { duration: 0.01 },
    }
  }
  return {
    variants: slideVariants[direction],
    transition: transitionConfig[direction] as Transition,
  }
}

export const flipVariants: Variants = {
  initial: { opacity: 0, rotateY: 90, scale: 0.95 },
  animate: { opacity: 1, rotateY: 0, scale: 1 },
  exit: { opacity: 0, rotateY: -90, scale: 0.95 },
}

export const flipTransition = { duration: 0.4, ease: [0.4, 0, 0.2, 1] }